import DocumentTitle from 'react-document-title';
import { Navigate } from 'react-router-dom';

import Layout from 'hb-react/frontoffice/apps/Mentoring/components/Layout';
import { ApplyMenteeToMentor } from 'hb-react/frontoffice/apps/Mentoring/container/Application/MenteeToMentor';
import { useMentoringOutletContext } from 'hb-react/frontoffice/apps/Mentoring/container/ProgramControlledAccess';
import PageNotFound from 'hb-react/frontoffice/apps/Mentoring/pages/PageNotFound';
import { getLowerCaseMenteeLabel } from 'hb-react/frontoffice/apps/Mentoring/utils';
import { getApplicationPageTitle } from 'hb-react/frontoffice/apps/Mentoring/utils/applicationUtils';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

interface ApplyMenteeToMentorRelationshipProps {
  disabledAccess?: boolean;
}

export const ApplyMenteeToMentorRelationship = ({
  disabledAccess,
}: ApplyMenteeToMentorRelationshipProps) => {
  const { currentUser, currentNetwork } = useDefaultAppContexts();
  const { program } = useMentoringOutletContext();

  if (currentUser?.can_be_a_mentee === false) {
    return <Navigate to="../../../mentors" />;
  }

  if (!program || disabledAccess || program.mode === 'admin_match') {
    return <PageNotFound />;
  }

  return (
    <>
      <DocumentTitle
        title={getApplicationPageTitle({
          label: getLowerCaseMenteeLabel(program.mentee_label),
          currentNetwork,
        })}
      />
      <Layout>
        <ApplyMenteeToMentor program={program} />
      </Layout>
    </>
  );
};
